export const RECOMENDACAO_COLORS = {
  compra: 'green',
  venda: 'red',
  manutencao: 'orange',
  atencao: 'amber',
  em_analise: 'blue-grey',
  venda_urgente: 'deep-orange darken-4',
  neutro: 'blue-grey lighten-1',
}

export const RECOMENDACAO_TEXT_COLORS = {
  compra: '#56AF79',
  venda: '#E74C3C',
  manutencao: '#F2994A',
  atencao: '#E0AF00',
  em_analise: '#6F7F91',
  venda_urgente: '#8C1D04',
  neutro: '#78909C',
}

export const RECOMENDACAO_LABELS = {
  compra: 'Compra',
  venda: 'Venda',
  manutencao: 'Manutenção',
  atencao: 'Atenção',
  em_analise: 'Em Análise',
  venda_urgente: 'Venda Urgente',
  neutro: 'Neutro',
}

export const RECOMENDACAO_OPTIONS = [
  { text: 'Compra', value: 'compra' },
  { text: 'Venda', value: 'venda' },
  { text: 'Manutenção', value: 'manutencao' },
  { text: 'Atenção', value: 'atencao' },
  { text: 'Em Análise', value: 'em_analise' },
  { text: 'Venda Urgente', value: 'venda_urgente' },
  { text: 'Neutro', value: 'neutro' },
]
